module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-container"
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "notification__header clearfix"
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification__content",
    on: {
      "click": _vm.notificationClicked
    }
  }, [_vm._v("Aujourd'hui, vous avez " + _vm._s(_vm.eventsNbr) + " actions à mener")]), _vm._v(" "), _c('div', {
    staticClass: "notification__footer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification-bg",
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e936c0ec!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Notification.vue
// module id = 41
// module chunks = 0